import { ref, onMounted } from '@vue/composition-api'
import apiInstance from '@/libs/axios'


export function usePage(request, query, ...ctx) {
    const isLoading = ref(false)
    const isLoadingMore = ref(false)
    const data = ref(null)
    const error = ref(null)
    const nextPage = ref(null)

    const fetchPageData = (query, controller) => {
        return new Promise((resolve, reject) => {
            isLoading.value = true
            request(query, controller)
                .then((response) => {
                    data.value = response.data.data || response.data
                    nextPage.value = response.data?.links?.next || null
                    isLoading.value = true
                    error.value = null
                    resolve('1');
                })
                .catch((e) => {
                    error.value = e.message
                    reject();
                })
                .finally(() => {
                    isLoading.value = false
                })
        })
    }

    const loadMoreData = () => {
        if (nextPage.value) {
            isLoadingMore.value = true
            apiInstance.get(nextPage.value.replace(/https?:\/\/[A-Za-z0-9_:.]+/gi, '')) // delete http://domain.com:port
                .then((response) => {
                    data.value.push(...response.data.data)
                    nextPage.value = response.data.links.next
                    isLoadingMore.value = true
                    error.value = null
                })
                .catch((e) => {
                    error.value = e.message
                })
                .finally(() => {
                    isLoadingMore.value = false
                })
        }
    }

    onMounted(() => {
        // check for route params before fetch
        if (!(ctx[0] && ctx[0].root.$route.params && Object.keys(ctx[0].root.$route.params).length) && (!ctx[1])) {
            fetchPageData()
        }
    })

    return {
        isLoading,
        isLoadingMore,
        data,
        error,
        loadMoreData,
        fetchPageData
    }
}
